import React from 'react'
import cash from "../static/img/Cash_Payment_pana.svg";

const EfectivoImg = ({theme}) => {
  return (
    <div className='text-container' style={{color: theme.secondary}}>
      <span className="tituloRealizar text-right-block">¡Mantente al día!</span>
      <span className="text-right-block">Te facilitamos el pago de tu servicio presencial</span>
      <div className="d-flex justify-content-end mt-2">
        <img src={cash} alt="Métodos de Pago" className='img-bill-2' />
      </div>
    </div>
  )
}

export default EfectivoImg
